import { Component, useCallback, useEffect } from 'react';
import { LayoutAnimation, StyleProp, ViewStyle } from 'react-native';
import { useDispatch, useSelector } from '@shared/store';
import { MBLinkPreviewComponent } from '../components';
import * as Actions from '../store/actions';

interface Props {
  url: string;
  style?: StyleProp<ViewStyle>;
  onLongPress?: (url: string, node: Component) => void;
}

export function MBLinkPreview({ url, style, onLongPress }: Props) {
  const dispatch = useDispatch();
  const link: MBLinkPreviewData | null = useSelector(
    state => state.chatLinkPreview.linkPreviewFromUrl[url] ?? null,
  );
  const fetchPreview = useCallback(
    (urlToFetch: string) => dispatch(Actions.fetchLinkPreview(urlToFetch)),
    [dispatch],
  );

  useEffect(() => {
    fetchPreview(url);
  }, [fetchPreview, url]);

  useEffect(() => {
    if (!!LayoutAnimation) {
      LayoutAnimation.configureNext(LayoutAnimation.Presets.easeInEaseOut);
    }
  }, [link]);

  return <MBLinkPreviewComponent link={link} style={style} onLongPress={onLongPress} />;
}
